import { apiRequest } from './apiClient';

export const createMarketInquiry = (payload) =>
  apiRequest('/market/inquiries', {
    method: 'POST',
    auth: true,
    body: payload,
  });

export const getSubmittedInquiries = () =>
  apiRequest('/market/inquiries', {
    auth: true,
  });

export const getReceivedInquiries = () =>
  apiRequest('/market/inquiries/received', {
    auth: true,
  });
